import { render } from "./Favorites.vue?vue&type=template&id=7ffd9708"
import script from "./Favorites.vue?vue&type=script&lang=js"
export * from "./Favorites.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/reports/Favorites.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7ffd9708"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7ffd9708', __exports__)) {
    api.reload('7ffd9708', __exports__)
  }
  
  module.hot.accept("./Favorites.vue?vue&type=template&id=7ffd9708", () => {
    api.rerender('7ffd9708', render)
  })

}


export default __exports__